import { message } from 'antd';
import axios from 'axios';
import { get } from 'lodash';
import store from 'store2';

axios.defaults.baseURL = import.meta.env.VITE_API;

axios.interceptors.request.use((config) => {
    config.headers['Accept-Language'] = store.get('i18nextLng', 'zh');

    if (store.has('accessToken')) {
        config.headers.Authorization = 'Bearer ' + store.get('accessToken');
    }

    return config;
});

axios.interceptors.response.use(
    (res) => {
        if (res.data.code !== 0) {
            message.error(res.data.msg);

            return Promise.reject(new Error(res.data.msg));
        }

        return res;
    },
    (err) => {
        if (err.status === 401) {
            store.clear();

            window.location.href = `${import.meta.env.VITE_LOGIN}?redirect=${encodeURIComponent(window.location.href)}`;

            return Promise.reject(err);
        }

        message.error(get(err, 'response.data.msg', err.message));

        return Promise.reject(err);
    },
);

export default axios;
